var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.authAreaUrl},on:{"click":function($event){$event.preventDefault();return _vm.checkSignin(_vm.authAreaUrl)}}},[_vm._v(" "+_vm._s(_vm.authAreaUrl)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }